import { Dialog } from "primereact/dialog";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { JVRadioBtn } from "../../../shared/JVRadioBtn";
import { ITrainingSchedules } from "./Table";
import { ILogin } from "../../../models/Login";
import { JVTime } from "../../../shared/JVTime";
import { JVDate } from "../../../shared/JVDate";
import { Panel } from "primereact/panel";
import { format } from "date-fns";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
    open: boolean,
    singleData: ITrainingSchedules,
    hideDialog: () => void,
    toast: any,
    reloadTable: () => void,
}

interface IStatusForm {
    schedule_ID?: number,
    training_Status?: boolean,
    training_Status_Reason?: string,
    no_Of_Trainees?: number,
    training_Date?: Date,
    // training_Date_To?: Date,
    training_Time_From?: Date,
    training_Time_To?: Date,
    ans_1?: boolean,
    ans_2?: boolean,
    ans_3?: boolean,
}

interface IStatusFormTemp {
    schedule_ID?: number | null,
    training_Status?: string | null,
    training_Status_Reason?: string | null,
    no_Of_Trainees?: number | null,
    training_Date?: Date | null,
    // training_Date_To?: Date | null,
    training_Time_From?: Date | null,
    training_Time_To?: Date | null,
    ans_1?: string | null,
    ans_2?: string | null,
    ans_3?: string | null,
}

const schema = yup.object({
    training_Status: yup.string().required("Training Complete Status is required"),
    training_Status_Reason: yup.string().nullable(),
});

export const TrainingStatusForm = (props: IProps) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [shwAns, setShwAns] = useState<boolean>(false);
    const [shwReject, setShwReject] = useState<boolean>(false);
    const [disableAll, setDisableAll] = useState<boolean>(false);
    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IStatusFormTemp>({
        resolver: yupResolver(schema),
        defaultValues: { training_Status: "" },
        shouldFocusError: false
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const saveToDBYes = async (data: IStatusForm) => {
        if (data.ans_1 === null) {
            props.toast.current.show({ severity: 'error', detail: "Please Ans Question 1", life: 3000 });
            setLoading(false);
            return;
        }
        if (data.ans_2 === null) {
            props.toast.current.show({ severity: 'error', detail: "Please Ans Question 3", life: 3000 });
            setLoading(false);
            return;
        }
        if (data.ans_3 === null) {
            props.toast.current.show({ severity: 'error', detail: "Please Ans Question 3", life: 3000 });
            setLoading(false);
            return;
        }

        data.training_Time_From = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date(data.training_Time_From || "").getHours() - 5,
            new Date(data.training_Time_From || "").getMinutes(),
            new Date(data.training_Time_From || "").getSeconds());
        data.training_Time_To = new Date(new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
            new Date(data.training_Time_To || "").getHours() - 5,
            new Date(data.training_Time_To || "").getMinutes(),
            new Date(data.training_Time_To || "").getSeconds());
        setLoading(true);
        let newBody: any = { ...data };
        if (props.singleData.training_Status_ID) newBody.training_Status_ID = props.singleData.training_Status_ID;

        if (data.training_Time_From > data.training_Time_To) {
            props.toast.current.show({ severity: 'error', detail: "Actual Time From Can not be greater than Actual Time To", life: 3000 });
            setLoading(false);
            return;
        }

        const method = props.singleData.training_Status_ID === null ? "POST" : "PUT";
        const url = props.singleData.training_Status_ID === null ? "addTrainingStatusFormYes" : "updateTrainingStatusForm";
        const response = await Fetch(("CarnivalTraining/" + url), method, newBody, null, props.toast);

        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            onHide();
        } else setLoading(false);
    }

    const saveToDBNo = async (data: IStatusForm) => {
        setLoading(true);
        let newBody: any = { ...data };
        if (props.singleData.training_Status_ID) newBody.training_Status_ID = props.singleData.training_Status_ID;
        const method = props.singleData.training_Status_ID === null ? "POST" : "PUT";
        const url = props.singleData.training_Status_ID === null ? "addTrainingStatusFormNo" : "updateTrainingStatusForm";
        const response = await Fetch(("CarnivalTraining/" + url), method, newBody, null, props.toast);

        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            onHide();
        } else setLoading(false);
    }

    const getDataOfForm = async (data: number) => {
        const response = await Fetch("CarnivalTraining/GetTrainingStatusForm", "GET", null, `statusID=${data}`, props.toast);

        if (response) {
            const data: IStatusForm = await response.json();
            setValue("training_Status", data.training_Status === true ? "Completed" : "Cancelled");
            setValue("training_Status_Reason", data.training_Status_Reason);
            setValue("training_Date", new Date(data.training_Date || ""));
            // setValue("training_Date_To", new Date(data.training_Date_To || ""));
            setValue("no_Of_Trainees", data.no_Of_Trainees);
            setValue("training_Time_From", new Date(data.training_Time_From || ""));
            setValue("training_Time_To", new Date(data.training_Time_To || ""));
            setValue("ans_1", data.ans_1 === true ? "Yes" : "No");
            setValue("ans_2", data.ans_2 === true ? "Yes" : "No");
            setValue("ans_3", data.ans_3 === true ? "Yes" : "No");
        }
    }

    const onSubmit = (data: IStatusFormTemp) => {
        const newBodyYes: any = {
            schedule_ID: props.singleData.schedule_ID,
            training_Status: data.training_Status === "Completed" ? true : (data.training_Status === "Cancelled" ? false : null),
            no_Of_Trainees: data.no_Of_Trainees,
            training_Date: data.training_Date,
            // training_Date_To: data.training_Date_To,
            training_Time_From: data.training_Time_From,
            training_Time_To: data.training_Time_To,
            ans_1: data.ans_1 === "Yes" ? true : false,
            ans_2: data.ans_2 === "Yes" ? true : false,
            ans_3: data.ans_3 === "Yes" ? true : false,
        };
        const newBodyNo: any = {
            schedule_ID: props.singleData.schedule_ID,
            training_Status: data.training_Status === "Completed" ? true : (data.training_Status === "Cancelled" ? false : null),
            training_Status_Reason: data.training_Status_Reason
        };

        if (data.training_Status === "Completed" && ((new Date(newBodyYes?.training_Time_To).getHours() === new Date().getHours() && new Date(newBodyYes?.training_Time_To).getMinutes() < new Date().getMinutes()) || (new Date(newBodyYes?.training_Time_To).getHours() < new Date().getHours())) && new Date(newBodyYes?.training_Date).getDate() <= new Date().getDate() && (new Date(newBodyYes?.training_Date).getMonth() + 1) <= (new Date().getMonth() + 1) && new Date(newBodyYes?.training_Date).getFullYear() <= new Date().getFullYear()) {
            saveToDBYes(newBodyYes);
        } else if (data.training_Status === "Completed" && ((new Date(newBodyYes?.training_Time_To).getHours() === new Date().getHours() && new Date(newBodyYes?.training_Time_To).getMinutes() > new Date().getMinutes()) || (new Date(newBodyYes?.training_Time_To).getHours() > new Date().getHours()))) {
            props.toast.current.show({ severity: 'error', detail: "Can not mark as completed as training time is not completed yet", life: 3000 });
        };

        if (data.training_Status === "Cancelled") {
            saveToDBNo(newBodyNo);
        }
    }
    const onHide = () => {
        setValue("training_Status_Reason", null);
        setValue("training_Status", null);
        setValue("training_Date", null);
        // setValue("training_Date_To", null);
        setValue("training_Time_From", null);
        setValue("training_Time_To", null);
        setValue("no_Of_Trainees", null);
        setValue("ans_1", null);
        setValue("ans_2", null);
        setValue("ans_3", null);
        setShwAns(false);
        setShwReject(false);
        setLoading(false);
        setDisableAll(false);
        props.reloadTable();
        props.hideDialog();
    }
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "training_Status") {
                if (value.training_Status != null && value.training_Status === "Completed") {
                    setShwAns(true);
                    setShwReject(false);
                    if (props.singleData.training_Status === false) {
                        setValue("training_Date", new Date(props.singleData.training_Date || ""));
                        // setValue("training_Date_To", new Date(props.singleData.training_Date_To || ""));
                        setValue("training_Time_From", new Date(props.singleData.training_Time_From || ""));
                        setValue("training_Time_To", new Date(props.singleData.training_Time_To || ""));
                        setValue("no_Of_Trainees", props.singleData.no_Of_Trainees);
                        setValue("ans_1", null);
                        setValue("ans_2", null);
                        setValue("ans_3", null);
                    }
                } else if (value.training_Status != null && value.training_Status === "Cancelled") {
                    setShwAns(false);
                    setShwReject(true);
                } else {
                    setShwAns(false);
                    setShwReject(false);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch, shwAns, shwReject]);

    useEffect(() => {
        if (props.open && props.singleData.training_Status_ID && !(_roles.includes(1) || _roles.includes(26))) {
            setDisableAll(true);
        }
        if (props.open && props.singleData.training_Status === null) {
            setValue("training_Date", new Date(props.singleData.training_Date || ""));
            // setValue("training_Date_To", new Date(props.singleData.training_Date_To || ""));
            setValue("training_Time_From", new Date(props.singleData.training_Time_From || ""));
            setValue("training_Time_To", new Date(props.singleData.training_Time_To || ""));
            setValue("no_Of_Trainees", props.singleData.no_Of_Trainees);
            setValue("ans_1", null);
            setValue("ans_2", null);
            setValue("ans_3", null);
        } else {
            if (props.open) getDataOfForm(props.singleData.training_Status_ID ?? 0);
        }
        if (props.open && props.singleData.training_Status === false) {
            setValue("training_Status", "Cancelled");
        }
        if (props.open && props.singleData.training_Status === true) {
            setValue("training_Status", "Completed");
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Update Training Status" modal className="p-fluid" onHide={() => onHide()}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVRadioBtn disabled={disableAll} inline label="Training Completed" data={["Completed", "Cancelled"]} column={3} control={control} name="training_Status" />
                {shwReject && <JVInput column={1} disabled={!shwReject} label="Reason For Cancelled" control={control} name="training_Status_Reason" error={errors.training_Status_Reason?.message} />}
                {shwAns && <>
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end"></div>
                    <hr></hr>
                    <div className="flex align-content-evenly w-full">
                        <Panel header="Training From Date" style={{ width: "25%" }}>
                            <p className="m-0">{format(new Date(props.singleData.training_Date || ""), 'dd/MM/yyyy').toUpperCase()}</p>
                        </Panel>
                        {/* <Panel header="Training To Date" style={{ width: "20%" }}>
                            <p className="m-0">{format(new Date(props.singleData.training_Date_To || ""), 'dd/MM/yyyy').toUpperCase()}</p>
                        </Panel> */}
                        <Panel header="Training Time From" style={{ width: "25%" }}>
                            <p className="m-0">{format(new Date(props.singleData.training_Time_From || ""), 'hh:mm  a').toUpperCase()}</p>
                        </Panel>
                        <Panel header="Training Time To" style={{ width: "25%" }}>
                            <p className="m-0">{format(new Date(props.singleData.training_Time_To || ""), 'hh:mm  a').toUpperCase()}</p>
                        </Panel>
                        <Panel header="No Of Trainees" style={{ width: "25%" }}>
                            <p className="m-0">{props.singleData.no_Of_Trainees}</p>
                        </Panel>
                    </div>
                    <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-3"></div>
                    <JVDate disabled={disableAll} required column={4} label="Actual Training Date" control={control} name="training_Date" />
                    {/* <JVDate disabled={disableAll} required column={4} label="Actual To Date" control={control} name="training_Date_To" /> */}
                    <JVInput disabled={disableAll} column={2} required label="Actual No Of Trainees" type="number" control={control} name="no_Of_Trainees" error={errors.no_Of_Trainees?.message} />
                    <JVTime disabled={disableAll} column={2} label="Actual Time From" required control={control} name="training_Time_From" error={errors.training_Time_From?.message} />
                    <JVTime disabled={disableAll} column={2} label="Actual Time To" required control={control} name="training_Time_To" error={errors.training_Time_To?.message} />
                    <div className="field col-12 md:col-12 flex ml-2"><p style={{ paddingTop: "5px", width: "70%" }}>Did you find the People are paying the attention ?</p><JVRadioBtn disabled={disableAll} inline label="" data={["Yes", "No"]} column={6} control={control} name="ans_1" /></div>
                    <div className="field col-12 md:col-12 flex ml-2"><p style={{ paddingTop: "5px", width: "70%" }}>Did you find the People are Ex-level of knowledge in this Topic ?</p><JVRadioBtn disabled={disableAll} inline label="" data={["Yes", "No"]} column={6} control={control} name="ans_2" /></div>
                    <div className="field col-12 md:col-12 flex ml-2"><p style={{ paddingTop: "5px", width: "70%" }}>Did you Find it was Highly Recommended for them ?</p><JVRadioBtn disabled={disableAll} inline label="" data={["Yes", "No"]} column={6} control={control} name="ans_3" /></div>
                </>}
                {((props.singleData.training_Status === null) || (_roles.includes(1) || _roles.includes(26))) && <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit" loading={loading} disabled={loading}></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={() => onHide()} type="button" className="p-button-outlined surface-200"></Button>
                </div>}
            </form>
        </Dialog>
    );
}